export default __webpack_public_path__ + "/static/media/concerirge.43f0b21c.svg";